import React, { useMemo } from 'react'
import { useNavigate, useMatch } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { format, startOfWeek, endOfWeek } from 'date-fns'
import { DATE_PARAM_FORMAT } from '@/v2/constants'
import MiniCalendar from '@/v2/components/common/MiniCalendar'
import AppointmentSections from '@/v2/containers/sidebar/AppointmentSections'
import { nowOnClinicTimezone } from '@/v2/utils/convert'
import ClinicSwitcher from '@/v2/containers/sidebar/ClinicSwitcher'
import { SidebarWrapper, Topbar } from './styles'

const Sidebar = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const match = useMatch('/v2/calendar/:view/:date')
  const matchViewOnly = useMatch('/v2/calendar/:view')
  const { params } = match || matchViewOnly || {}
  const { view = 'day', date } = params || {}

  const calendarDate = useMemo(() => {
    const day = date ? new Date(date.replace(/-/g, '/')) : nowOnClinicTimezone()
    return view === 'day'
      ? day
      : view === 'week'
      ? [startOfWeek(day), endOfWeek(day)]
      : null
  }, [view, startOfWeek, endOfWeek, date, nowOnClinicTimezone])

  return (
    <SidebarWrapper theme={theme.palette}>
      <Topbar theme={theme.palette}>
        <ClinicSwitcher />
      </Topbar>
      <MiniCalendar
        key={`${view}-${date}`}
        date={calendarDate}
        onSelect={newDate => {
          const formattedDate = format(newDate, DATE_PARAM_FORMAT)
          return navigate(`/v2/calendar/day/${formattedDate}`)
        }}
        onClickMonth={date =>
          navigate(`/v2/calendar/month/${format(date, DATE_PARAM_FORMAT)}`)
        }
      />
      <AppointmentSections />
    </SidebarWrapper>
  )
}

export default Sidebar
